module.exports = __webpack_public_path__ + "img/p6.e1d175bd.png";